import packageJson from '../../../../package.json'
import { compareVersions, isVersionAtMost } from '../../helpers/version'
import { ChangeLogEntry } from './ChangeLog'

export const getCurrentAppVersion = (): string => packageJson.version

/**
 * Hides entries prepared for a release that hasn't gone out yet, so they only
 * appear once an app version matching (or exceeding) their version is deployed.
 */
export const filterChangeLogEntriesByCurrentVersion = (
    changeLogEntries: ChangeLogEntry[],
    currentVersion: string = getCurrentAppVersion(),
): ChangeLogEntry[] => changeLogEntries.filter(changeLogEntry => isVersionAtMost(changeLogEntry.version, currentVersion))

/**
 * The backend sorts on GET, so this is only needed to reposition a single added/edited entry within the
 * already-loaded list: POST/PATCH return just that one entry, not a freshly-sorted full list.
 */
export const sortChangeLogEntriesByVersionDescending = (changeLogEntries: ChangeLogEntry[]): ChangeLogEntry[] => (
    [...changeLogEntries].sort((entryA, entryB) => compareVersions(entryB.version, entryA.version))
)
